/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import '@fortawesome/fontawesome-free/js/all';
import './button';
import './toggle';
import './parralax';
import './translate';
import './swiper';
import './mapbox';
import './modal';
import './mapbox-single';

$(document).ready(() => {
  // console.log('Hello world');
});
